import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import axios from "axios";
import { DEFAULT_CONTENT } from "@/lib/content";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const UI = {
  nav: { events: ["Ивенты", "Events", "Ивенттер"], production: ["Продакшн", "Production", "Продакшн"], marketing: ["Маркетинг", "Marketing", "Маркетинг"], booking: ["Букинг", "Booking", "Букинг"], contacts: ["Контакты", "Contacts", "Байланыш"] },
  more: ["Подробнее", "Learn more", "Кененирээк"],
  learnMore: ["Узнать подробнее", "Learn more", "Кененирээк билүү"],
  discuss: ["Обсудить проект", "Discuss a project", "Долбоорду талкуулоо"],
  contact: ["Связаться", "Contact us", "Байланышуу"],
  directions: ["Наши направления", "Our directions", "Биздин багыттар"],
  directionsTitle: ["Четыре направления — одна команда", "Four directions — one team", "Төрт багыт — бир команда"],
  directionsLead: ["Мы работаем только под ключ: ивент, продакшн, маркетинг и букинг — это четыре грани одного проекта, которые ведёт одна команда от идеи до финала.", "We work turnkey only: events, production, marketing and booking are four facets of one project, led by one team from idea to finale.", "Биз ачкычка чейин гана иштейбиз: ивент, продакшн, маркетинг жана букинг — бир долбоордун төрт кырын бир команда идеядан аягына чейин алып барат."],
  clients: ["Нам доверяют", "Trusted by", "Бизге ишенишет"],
  clientsLead: ["Государственные структуры, международные организации и крупнейшие бренды региона.", "Government bodies, international organisations and the region's leading brands.", "Мамлекеттик түзүмдөр, эл аралык уюмдар жана аймактын ири бренддери."],
  cases: ["Проекты, которыми мы гордимся", "Projects we are proud of", "Сыймыктанган долбоорлорубуз"],
  casesEyebrow: ["Кейсы", "Cases", "Кейстер"],
  allProjects: ["Все проекты", "All projects", "Бардык долбоорлор"],
  watch: ["Видео-отчёт", "Video recap", "Видео-отчёт"],
  viewCase: ["Смотреть кейс", "View case", "Кейсти көрүү"],
  wantSame: ["Хочу такое же событие", "I want an event like this", "Мага да ушундай иш-чара керек"],
  why: ["Почему выбирают нас", "Why clients choose us", "Эмне үчүн бизди тандашат"],
  whyLead: ["Доверьте нам ваш ивент — и мы превратим его в незабываемое событие.", "Trust us with your event — and we'll turn it into something unforgettable.", "Ивентиңизди бизге ишениңиз — биз аны унутулгус окуяга айлантабыз."],
  stages: ["Как мы работаем", "How we work", "Биз кантип иштейбиз"],
  stage: ["Этап", "Stage", "Этап"],
  included: ["Что входит в услугу", "What's included", "Кызматка эмне кирет"],
  categories: ["Направления работы", "We cover", "Иш багыттары"],
  dirCases: ["Кейсы направления", "Cases in this direction", "Багыттын кейстери"],
  otherDirs: ["Другие направления", "Other directions", "Башка багыттар"],
  founder: ["Основатель", "Founder", "Негиздөөчү"],
  contactTitle: ["Давайте создадим ваше событие", "Let's create your event", "Келиңиз, иш-чараңызды бирге жаратабыз"],
  contactLead: ["Расскажите о задаче — мы свяжемся с вами и предложим концепцию. Или напишите напрямую в WhatsApp.", "Tell us about your task — we'll get back with a concept. Or message us directly on WhatsApp.", "Милдетиңиз жөнүндө айтып бериңиз — биз байланышып, концепция сунуштайбыз. Же түз WhatsApp'ка жазыңыз."],
  formName: ["Ваше имя", "Your name", "Атыңыз"],
  formPhone: ["Телефон / WhatsApp", "Phone / WhatsApp", "Телефон / WhatsApp"],
  formDir: ["Направление", "Direction", "Багыт"],
  formAny: ["Комплексно / не знаю", "Full package / not sure", "Комплекстүү / билбейм"],
  formMsg: ["Коротко о мероприятии", "About your event", "Иш-чара жөнүндө кыскача"],
  formSend: ["Оставить заявку", "Send request", "Арыз калтыруу"],
  formSent: ["Спасибо! Мы скоро свяжемся с вами.", "Thank you! We'll be in touch shortly.", "Рахмат! Жакында байланышабыз."],
  formErr: ["Не удалось отправить. Напишите нам в WhatsApp.", "Couldn't send. Please message us on WhatsApp.", "Жөнөтүлгөн жок. WhatsApp'ка жазыңыз."],
  formLimit: ["Слишком много заявок подряд. Попробуйте позже или напишите в WhatsApp.", "Too many requests. Please try later or message us on WhatsApp.", "Өтө көп арыз. Кийинчерээк аракет кылыңыз же WhatsApp'ка жазыңыз."],
  writeWa: ["Написать в WhatsApp", "Message on WhatsApp", "WhatsApp'ка жазуу"],
  rights: ["Все права защищены", "All rights reserved", "Бардык укуктар корголгон"],
  scroll: ["Листайте", "Scroll", "Ылдый"],
  home: ["Главная", "Home", "Башкы бет"],
  waMsg: ["Здравствуйте! Хочу узнать подробнее об услугах Dari Event.", "Hello! I'd like to learn more about Dari Event services.", "Саламатсызбы! Dari Event кызматтары жөнүндө кененирээк билгим келет."],
  photos: ["Фото", "Photos", "Сүрөттөр"],
  video: ["Видео", "Video", "Видео"],
};

const LANGS = ["ru", "en", "ky"];
const Ctx = createContext(null);

const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);
const deepMerge = (def, saved) => {
  if (saved === undefined || saved === null) return def;
  if (Array.isArray(def) && Array.isArray(saved)) {
    return saved.map((s, i) => (isObj(s) && isObj(def[i]) && !("ru" in s) ? deepMerge(def[i], s) : s));
  }
  if (isObj(def) && isObj(saved)) {
    const out = { ...def };
    Object.keys(saved).forEach((k) => { out[k] = deepMerge(def[k], saved[k]); });
    return out;
  }
  return saved;
};

export const resolveImg = (src) => (src && src.startsWith("/api/") ? `${BACKEND_URL}${src}` : src || "");

export function SiteProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const s = typeof window !== "undefined" ? localStorage.getItem("dari_lang") : null;
    return LANGS.includes(s) ? s : "ru";
  });
  const [content, setContent] = useState(DEFAULT_CONTENT);

  const reload = useCallback(async () => {
    if (!BACKEND_URL) return;
    try {
      const res = await axios.get(`${API}/content`);
      const data = res.data?.data;
      setContent(isObj(data) ? deepMerge(DEFAULT_CONTENT, data) : DEFAULT_CONTENT);
    } catch (e) {
      setContent(DEFAULT_CONTENT);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);
  useEffect(() => { document.documentElement.lang = lang === "ky" ? "ky" : lang; }, [lang]);

  const value = useMemo(() => {
    const idx = LANGS.indexOf(lang);
    const t = (v) => {
      if (v == null) return "";
      if (typeof v === "string") return v;
      if (Array.isArray(v)) return v[idx] ?? v[0] ?? "";
      return v[lang] || v.ru || "";
    };
    const wa = (text) => {
      const num = content?.contacts?.whatsapp || "996555403700";
      return `https://wa.me/${num}?text=${encodeURIComponent(text || t(UI.waMsg))}`;
    };
    const setLang = (l) => { localStorage.setItem("dari_lang", l); setLangState(l); };
    return { lang, setLang, langs: LANGS, t, wa, content, reload };
  }, [lang, content, reload]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useSite = () => useContext(Ctx);
